exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".ImgButton__imgBtn___I6Yau{display:-ms-flexbox;display:flex;margin:.2rem;padding:.3rem!important}.ImgButton__title___3kq7o{margin:.4rem}.ImgButton__imgContainer___2BXoB{height:32px}img{height:100%}", "", {"version":3,"sources":["/home/jenkins/jenkins/workspace/mrsn-applications-deployment/release/Build/frontend/portal-frontend/src/components/ImgButton/ImgButton.css"],"names":[],"mappings":"AAAA,2BACE,oBAAqB,AACrB,aAAc,AACd,aAAe,AACf,uBAA0B,CAC3B,AAED,0BACE,YAAe,CAChB,AAED,iCACE,WAAa,CACd,AAED,IACE,WAAa,CACd","file":"ImgButton.css","sourcesContent":[".imgBtn {\n  display: -ms-flexbox;\n  display: flex;\n  margin: 0.2rem;\n  padding: 0.3rem!important;\n}\n\n.title {\n  margin: 0.4rem;\n}\n\n.imgContainer {\n  height: 32px;\n}\n\nimg {\n  height: 100%;\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"imgBtn": "ImgButton__imgBtn___I6Yau",
	"title": "ImgButton__title___3kq7o",
	"imgContainer": "ImgButton__imgContainer___2BXoB"
};